import RoutineWork from './views/routine-work.c';
export default RoutineWork;
